<h3 *ngIf="!loading && mode === 'New'">Create Role</h3>
<h3 *ngIf="!loading && mode === 'Edit'">Modify Role</h3>
<h3 *ngIf="loading">Loading</h3>

<form *ngIf="roleForm" nz-form [formGroup]="roleForm" (ngSubmit)="doSubmit()">
	<nz-card nzTitle="Role Form" *ngIf="!loading" [nzExtra]="saveTmpl">
		<ng-template #saveTmpl>
			<button *ngIf="mode == 'New'" nz-button nzType="primary" [disabled]="roleForm.invalid">Create</button>
			<button *ngIf="mode == 'Edit'" nz-button nzType="primary" [disabled]="roleForm.invalid">Save</button>
		</ng-template>


		<!-- Role Name -->
		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzRequired>Role Name</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input formControlName="name" placeholder="Name" />
			</nz-form-control>
		</nz-form-item>

		<!-- Description -->
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Description</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input formControlName="description" placeholder="Description" />
			</nz-form-control>
		</nz-form-item>
	</nz-card>

	<nz-card nzTitle="Agent Linking" *ngIf="mode === 'Edit'" class="mt-5">
		<h3>Agents</h3>

		<nz-table
			#agentTable
			nzSize="small"
			[nzData]="role!.agents"
			[nzFrontPagination]="true"
			[nzPageSize]="30"
			[nzShowPagination]="true">
			<thead>
				<tr>
					<th>ID</th>
					<th>Agent Name</th>
					<th>Agent Surname</th>
					<th class="text-center">Link</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let agent of agentTable.data">
					<td>{{ agent.agentId }}</td>
					<td>{{ agent.agentName }}</td>
					<td>{{ agent.agentSurname }}</td>
					<td class="text-center">
						<label nz-checkbox [(ngModel)]="agent.linked" [ngModelOptions]="{standalone: true}" name="agent_link_{{agent.agentId}}"></label>
					</td>
				</tr>
			</tbody>
		</nz-table>
	</nz-card>

	<div class="text-right mt-3" *ngIf="mode == 'Edit'">
		<button nz-button nzType="primary" [disabled]="roleForm.invalid">Save</button>
	</div>

</form>
